<template>
    <CHeader fixed light>
        <CToggler in-header
                  class="d-lg-none"
                  @click="$root.$emit('toggle-sidebar-mobile');hover()">
        </CToggler>
        <CToggler in-header
                  class="d-md-down-none"
                  @click="$root.$emit('toggle-sidebar');hover()">
        </CToggler>

        <div class='eg-logo'>
            <router-link :to="this.$parent.FisrtMenuItem">
                <img :src='getUserInfo.SL'>
                <!--<img src='../../assets/icons/ggcom.png'>-->
                <!-- <img src="../../assets/images/ggcom.png" /> -->
            </router-link>
        </div>
        <CHeaderNav class="mr-2 d-none d-md-block">
            <!-- back button -->
            <!--<CHeaderNavItem class="d-md-down-none">
                <CButton class="d-md-down-none c-header-toggler"
                         @click="backButton()">
                    <i class="fa fa-chevron-left"></i>
                </CButton>
            </CHeaderNavItem>-->
            <!-- timer -->
            <!--<CHeaderNavItem class="d-md-down-none timer-width">
                <span class="time-indicator">{{ DateTime | moment("DD MMM YYYY h:mm:ss a") }}</span>
            </CHeaderNavItem>-->

            
        </CHeaderNav>

        <CHeaderNav class="mr-auto d-none d-lg-flex flex-grow-1">
            <!-- marquee -->
            <CHeaderNavItem class="d-md-down-none w-100">
                <router-link :to="{ path:'/DASH/AA'}" tag='div' class="announcementWrapper" v-show="haveAnnouncement">
                    <div class="notificationMarquee">
                        <!-- <p id="marqueeStyle" ref="marqueeStyle" :style="WordCount()">{{marqueeText[currentNumber]}}</p>-->
                        <p :style="WordCount() ">{{marqueeText[currentNumber]}}</p>
                    </div>
                </router-link>
            </CHeaderNavItem>
        </CHeaderNav>

        <CHeaderNav class="mr-2 mr-md-3 ml-auto">
            <!-- action indicator -->
            <CHeaderNavItem class="d-flex d-md-down-none" v-if="this.getUserInfo.AT < 4">
                <div class="top-actionButtons" @click="btnClick('Deposit')">
                    <i class="fa-solid fa-circle-dollar-to-slot text-white"></i>
                    <span class="badge rounded-circle" style="background: #30878e;" :style="(this.getPendingDeposit > 99) ? 'font-size:8.5px;' : ''" >
                        <span>{{ (this.getPendingDeposit <= 99) ? this.getPendingDeposit : '99+' }} </span>
                    </span>
                </div>
                <div class="top-actionButtons" @click="btnClick('Withdraw')">
                    <i class="fa fa-money-bill text-white"></i>
                    <span class="badge rounded-circle" style="background: #e53636;" :style="(this.getPendingWithdrawal > 99) ? 'font-size:8.5px;' : ''">
                        <span>{{ (this.getPendingWithdrawal <= 99) ? this.getPendingWithdrawal : '99+' }}</span>
                    </span>
                </div>
                <div class="top-actionButtons" @click="btnClick('Promotion')">
                    <i class="fa-solid fa-percent text-white"></i>
                    <span class="badge rounded-circle" style="background: #6f6bd6;" :style="(this.getPendingPromotion > 99) ? 'font-size:8.5px;' : ''">
                        <span> {{ (this.getPendingPromotion <= 99) ? this.getPendingPromotion : '99+' }}</span>
                    </span>
                </div>
            </CHeaderNavItem>
            <!-- language -->
            <CHeaderNavItem>
                <CDropdown v-if='this.getLanguageIndex >= 0' :toggler-text="simplifyLanguage(this.getLangTreeSelect[this.getLanguageIndex].label)"
                           class="mx-2 languageBtn">
                    <div v-for="(data,index) in this.getLangTreeSelect">
                        <CDropdownItem class="dropdown-sm"
                                       @click="btnChgLang(index)">
                            <a class="dropdown-item dropdown-item-sm">
                                <span class="flagClass mr-1" :class="setFlag(data.id)"></span>

                                <!--<span>{{ data.label }}</span>-->
                                <span>{{ simplifyLanguage(data.label) }}</span>
                            </a>
                        </CDropdownItem>
                    </div>
                </CDropdown>
            </CHeaderNavItem>

            <CHeaderNavItem v-show="this.getUserInfo.IOL && this.getUserInfo.IMD">
                <div class="top-actionButtons bg-white" @click="changeView()">
                    <i class="view-desktop" aria-hidden="true" id="changeView"></i>
                    <!--<i class="fa fa-desktop" aria-hidden="true"></i>-->
                </div>
            </CHeaderNavItem>
            <CHeaderNavItem>
                <div class="top-actionButtons bg-white" @click="muteSound()">
                    <i class="volume-on" aria-hidden="true" id="muteVolume"></i>
                </div>
            </CHeaderNavItem>
            <HeaderDropdownNot v-if="this.getUserInfo.AT < 4" />
            <HeaderDropdownAccnt />

        </CHeaderNav>
    </CHeader>
</template>
<script>
    import { mapGetters, mapActions } from "vuex";

    import HeaderDropdownAccnt from "./HeaderDropdownAccnt";
    import HeaderDropdownNot from "./HeaderDropdownNot";
    import moment from "moment";

    import genericHelper from "../../modules/GenericHelper.js";
    import $ from 'jquery'

    export default {
        mixins: [genericHelper],
        components: {
            HeaderDropdownAccnt,
            HeaderDropdownNot
        },
        computed: {
            ...mapGetters('UserInfo', ['getUserInfo']),
            ...mapGetters("Language", [
                "getLanguage",
                "getLanguageOPT",
                "getLanguageIndex",
                "getLangTreeSelect",
                "getLangCode"
            ]),
            ...mapGetters('DashboardData', [
                'getPendingDeposit',
                'getPendingWithdrawal',
                'getPendingPromotion'
            ]),
        },
        data() {
            return {
                DateTime: this.getTodayDate(),
                currentNumber: 0,
                int_AnnouncementCount: 0,
                timer: null,
                timeout: [],
                marqueeText: [],
                marqueeWordLength: [],
                arry_al: [],
                haveAnnouncement: true,
                startRotationTO: null,
                AnnouncementRotation: null,
                arry_san: [], //system annoucement list
                int_RC: 100, //Row Count
                int_IC: 1, // Item Count
                isSideMenuMinimize: false,
            };
        },
        beforeRouteLeave(to, from, next) {
            clearTimeout(this.startRotationTO);
            next();
        },
        created() {
            this.getLangauge();
            this.getSystemAnnouncement();
            this.RotateAnnouncement();
            this.getSANList();
        },
        mounted() {
            
            this.startRotation();
            //this.getDate();
            
            var mutedepo = document.getElementById('DepositAudio');
            var mute3rdpartydepo = document.getElementById('3rdPartyDepositAudio');

            if (localStorage.getItem('isMute') == 'True') {
                mutedepo.muted = true;
                mute3rdpartydepo.muted = true;
                localStorage.setItem('isMute', 'True');
                document.getElementById('muteVolume').className = "volume-off";
            }
            else {
                mutedepo.muted = false;
                mute3rdpartydepo.muted = false;
                localStorage.setItem('isMute', 'False');
                document.getElementById('muteVolume').className = "volume-on";
            }
        },
        methods: {
            ...mapActions("Language", ["setLanguage", "setLanguageIndex", "setLangTreeSelect"]),
            startRotation() {
                this.nextAnnouncement();
                var that = this;
                this.startRotationTO = setTimeout(function () {
                    that.startRotation();
                }, 45000);
            },
            backButton: function () {
                this.$router.go(-1);
            },
            setSANList(data) {
                this.arry_san = data.Items;

            },
            getSANList() {

                var that = this;
                var currentLang = this.getLangCode;  //set current language, display EN for default
                var now = moment().format("YYYY-MM-DDTHH:mm:ss");
                var path = `p=1&n=100&s=STS&d=true&f[L_csv]=${currentLang}&f[STS_to]=${now}&f[ETS_from]=${now}`;

                this.getDataApi(`/api/aann/laann?${path}`,
                    function (d, s) {
                        if (s) {
                            that.setSANList(d.D);
                            that.$emit('getSANLength', parseInt(d.D.TotalItems));

                        }
                    });
            },
            getANNCookie() {
                let name = "ANNRead:" + this.getUserInfo.PC + ":" + this.getUserInfo.U +"=";
                let decodedCookie = decodeURIComponent(document.cookie);
                let ca = decodedCookie.split(';');
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            },
            setANNCookie(exdays) {
                const d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                let utcExpiredTimpStamp = d.setTime(d.getTime());
                let expires = "expires=" + d.toUTCString();
                document.cookie = "ANNRead:" + this.getUserInfo.PC + ":" + this.getUserInfo.U + "=" + utcExpiredTimpStamp + ";" + expires + ";path=/";
            },
            closeAfterAdd() {
                this.bool_PopAnnounce = !this.bool_PopAnnounce;
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            nextAnnouncement: function () {
                this.currentNumber += 1;
                if (this.currentNumber >= this.int_AnnouncementCount) {
                    this.currentNumber = 0;
                }
            },
            btnClick(path) {
                if (path == "Deposit") {
                    this.$router.push("/D/DDU");
                } else if (path == "Withdraw") {
                    this.$router.push("/W/WDU");
                } else if (path == "Promotion") {
                    this.$router.push("/P/PDU");
                }
            },
            muteSound() {
                var mutedepo = document.getElementById('DepositAudio');
                var mute3rdpartydepo = document.getElementById('3rdPartyDepositAudio');

                if (localStorage.getItem('isMute') != 'True') {
                    mutedepo.muted = true;
                    mute3rdpartydepo.muted = true;
                    localStorage.setItem('isMute', 'True');
                    document.getElementById('muteVolume').className = "volume-off";
                }
                else {
                    mutedepo.muted = false;
                    mute3rdpartydepo.muted = false;
                    localStorage.setItem('isMute', 'False');
                    document.getElementById('muteVolume').className = "volume-on";
                }
            },
            changeView() {
                if (localStorage.getItem('isOutletMobile') != 'True') {
                    localStorage.setItem('isOutletMobile', 'True');
                    document.getElementById('changeView').className = "view-mobile";
                }
                else {
                    localStorage.setItem('isOutletMobile', 'False');
                    document.getElementById('changeView').className = "view-desktop";
                }
                window.location.reload();
            },
            btnChgLang(index) {
                this.setLanguageIndex(index);
                let toLang = this.getLangTreeSelect[this.getLanguageIndex].id;
                this.$root.Language.getLanguage(this, toLang);
                window.localStorage.setItem('lang', toLang);
                this.setLangauge(toLang);
                this.getSystemAnnouncement();
                this.currentNumber = 0;
                //this.startRotation();
                this.RotateAnnouncement();
                
            },
            setFlag(languageCode) {
                return this.mapLanguageFlag(languageCode);
            },
            getDate() {
                var self = this;
                self.DateTime = new Date();
                self.timeout[0] = setTimeout(() => {
                    self.getDate();
                }, 1000);
            },
            getLangauge() {
                var that = this;
                this.getDataApi(`/api/dd/lang/0`,
                    function (d, s) {
                        if (s) {
                            let lang = window.localStorage.getItem('lang') || "en", langIdx = d.dropdownlist.findIndex(x => x.id == lang);
                            that.setLangTreeSelect(d.dropdownlist);
                            that.setLanguageIndex(langIdx);
                        }
                    });
            },
            setLangauge(toLang) {
                var that = this;
                var path = "f[lc]=" + toLang;
                this.getDataApi(`/api/lang/slis?${path}`,
                    function (d, s) {
                        if (s) {
                        }
                    });
            },
            simplifyLanguage(language) {
                var result = null;
                try {
                    //var result = language.substring(1, 3);
                    var result = language.substring(5);
                }
                catch (ex) {
                    result = null;
                }
                return result;
            },
            getSystemAnnouncement() {
                //get announcement for the specific user group, based on user login & user current language
                var that = this;
                var currentLang = this.getLangCode;  //set current language, display EN for default

                var now = moment().format("YYYY-MM-DDTHH:mm:ss");

                var path = `p=1&n=100&s=STS&d=true&f[L_csv]=${currentLang}&f[STS_to]=${now}&f[ETS_from]=${now}`;

                if (sessionStorage.getItem('tabId') === localStorage.getItem('tabId')) {
                    this.getDataApi(`/api/aann/laann?${path}`, function (d, s) {
                        if (s) {
                            localStorage.setItem('laann', JSON.stringify(d.D.Items));                            

                            if (d.D.Items.length < 1) {// hide announcement if no announcement available
                                that.haveAnnouncement = false;
                            }
                            else {
                                that.haveAnnouncement = true;
                            }
                            that.setAnnouncementList(d.D.Items);
                        }
                    });
                }
                else {
                    var arr_aann = JSON.parse(localStorage.getItem('laann'));

                    if (arr_aann.length < 1) {
                        that.haveAnnouncement = false;
                    }
                    else {
                        that.haveAnnouncement = true;
                    }
                    that.setAnnouncementList(arr_aann);
                }                
            },
            RotateAnnouncement() {
                this.getSystemAnnouncement();
                var that = this;
                this.AnnouncementRotation = setTimeout(function () {
                    that.RotateAnnouncement();
                }, 60000);
            },
            WordCount() {
                var wordCount = this.marqueeWordLength[this.currentNumber];
                if (typeof wordCount === "undefined") {
                    wordCount = 45;
                }
        
                if (wordCount <= 45) {
                   // return `animation: marquee 45s linear infinite `;
                    return `animation-duration: 45s`;
                }
                return `animation-duration: ${wordCount}s`;
               // return `animation:marquee ${wordCount}s linear infinite `;//here change the sort logo
            },
            setAnnouncementList(data) {

                this.arry_al = [];
                this.marqueeText = [];
                this.marqueeWordLength = [];
                this.arry_al = data;

                var arrL = parseInt(this.arry_al.length);

                this.int_AnnouncementCount = arrL;
                var i = 0;
                for (i = 0; i < arrL; i++) {
                    this.marqueeText.push(this.arry_al[i].AC);
                    this.marqueeWordLength.push(this.arry_al[i].AC.split(" ").length);
                }
            },
            hover() {
                if (this.isSideMenuMinimize) {
                    this.isSideMenuMinimize = false;
                    $(".time-indicator").removeClass('d-none');
                    $(".version").removeClass('d-none');
                } else if (!this.isSideMenuMinimize) {
                    this.isSideMenuMinimize = true;
                    $(".time-indicator").addClass('d-none');
                    $(".version").addClass('d-none');
                }
            }
            
        },
        watch: {
        },
    };
</script>
<style>
    @media only screen and (max-width: 1060px) {
        .mr-auto .notification {
            display: none;
        }
    }
    .c-header.c-header-fixed {
        z-index: 1031;
    }

    .time-indicator {
        /*position: fixed;
        bottom: 5px;
        left: 20px;*/
        color: #a9adcc;
        font-size: 9px;
        z-index: 9999;
        position: fixed;
        bottom: 5px;
        left: 90px;
        /* color: #fff; */
    }

    /*@media only screen and (max-width: 991px) {
        .time-indicator {
            display:none;
        }
    }*/


    .announcementWrapper {
        display: flex;
        width: 100%;
        cursor: pointer;
    }

    .AnnouncementHeader {
        background: #003e8a;
        width: 120px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 300;
        font-size: 12px;
    }

    .AnnouncementHeader i {
        font-size: 14px;
        margin-left: 5px;
    }

    .notificationMarquee {
        border-radius: 8px;
        font-size: large;
        color: #000;
        background: #E7E9FA;
        position: relative;
        overflow: hidden;
        height: 30px;
        /*width: calc(100% - 120px);*/
        width: calc(100% - 70px);
        margin: auto;
    }

    @keyframes marquee {
        0% {
            transform: translateX(100%);
        }

        100% {
            transform: translateX(-100%);
        }
    }

    .volume-off {
        background: url('../../assets/icons/speaker-off.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 23px;
        height: 23px;
    }

    .volume-on {
        background: url('../../assets/icons/speaker-on.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 23px;
        height: 23px;
    }

    .view-mobile {
        background: url('../../assets/icons/mobile-screen-solid.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 23px;
        height: 23px;
    }

    .view-desktop {
        background: url('../../assets/icons/desktop-solid.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 23px;
        height: 23px;
    }

    .notificationMarquee p {
        position: absolute;
        margin: 0;
        line-height: 30px;
        white-space: nowrap;
        min-width: 100%;
        width: fit-content;
        /*animation: marquee 45s linear infinite;*/
        animation: marquee linear infinite;
        font-size: 12px;
    }

    .notification {
        font-weight: bold;
    }

    .notification .badge {
        position: absolute;
        top: -10px;
        right: -7px;
        padding: 10px 10px;
        border-radius: 50%;
    }

    .notification .badge span {
        position: absolute;
        width: 10px;
        top: 5px;
        right: 5px;
        text-align: center;
        color: white;
    }

    .top-actionButtons {
        position: relative;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        margin: 0 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #0c1033;
    }

    .top-actionButtons i {
        font-size: 15px;
    }

    .top-actionButtons .badge {
        position: absolute;
        width: 18px;
        top: -5px;
        right: -9px;
        color: #fff;
        padding: 4px 2px;
        height: 18px;
        font-size:65%;
        display:flex;
        align-items:center;
        justify-content:center;
        font-size:10px;
    }

    .top-actionButtons:hover {
        background: rgba(36, 49, 71, 1);
        cursor: pointer;
    }

    .timer-width {
        width: 200px;
    }

    .flagClass {
        height: 24px;
        width: 24px;
    }

    .dropdown-menu {
        padding: 0;
    }
    .languageBtn  .dropdown-menu {
        padding: 0;
        max-height: 500px;
        overflow-y: scroll;
    }
    .dropdown-sm {
        max-width: 100%;
    }

    .dropdown-item-sm {
        max-width: 120px !important;
    }

    .i-subheader-h {
        height: 35px;
    }

    .i-mg-pd {
        padding: 5px 35px;
        margin: 0;
    }

    .font12 {
        font-size: 12px;
    }

    .bold {
        font-weight: bold !important;
    }

    .ann-green-bold {
        color: #297b01 !important;
        font-weight: bold !important;
    }

    .ann-red {
        color: #ef5565 !important;
    }

    .ann-underline {
        text-decoration: underline;
    }

    .ann-blue {
        color: #4464fc !important;
    }

    .ann-darkblue {
        color: #243147 !important;
    }

    .noWarp {
        overflow-wrap: break-word !important;
        white-space: pre-line !important;
        width: 100% !important;
    }

    .ann-table tr:nth-child(even) {
        background-color: rgb(235,237,239);
    }

    .text-center {
        text-align: center;
    }

    .floatRight {
        float: right;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        position: -webkit-sticky;
        position: sticky;
        right: 0;
    }

    .ann-table th:nth-child(2) {
        color: white;
        font-weight: normal;
        vertical-align: middle;
        width: 77px !important;
    }

    .ann-table td .floatRight {
        float: right;
        display: -webkit-box;
        display: -ms-flexbox;
        position: -webkit-sticky;
        position: sticky;
        margin-left: 35px;
        margin-top: -14px;
    }

    .languageBtn button {
        background: #E7E9FA;
        height: 25px;
        font-weight: bold;
        color: #0c1033;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/HeaderDropdown/Header.vue